import React, { Component } from 'react';
import PropTypes from 'prop-types';

import nagaLogo from '../../../../common/images/naga-logo.png';

class RegisterTitle extends Component {

  render() {
    const { t } = this.context;

    return (
      <div className="display-flex-inline-start">
        <img src={nagaLogo} alt="Naga Logo" className="register-container__wrapper__logo" />
        <h2 className="register-container__wrapper__title">{t('REGISTER.SIGN_UP_AS_NAGA_PARTNER')}</h2>
      </div>
    );
  }
}

RegisterTitle.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default RegisterTitle;



// WEBPACK FOOTER //
// ./src/app/main/register/components/register-title.js